// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"221":"fb3afe34","664":"2de21cbd"}[chunkId] + ".chunk.css";
};